import { render } from "./LbrxSearchBar.vue?vue&type=template&id=a8c8d8b0"
import script from "./LbrxSearchBar.vue?vue&type=script&lang=js"
export * from "./LbrxSearchBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__